import React, { useState, cloneElement, useEffect } from "react";
import Modal from "./Modals/Modal";
import { useLocale } from "../../localization/LocaleProvider";

const PreviewPaginator = (props) => {
    const [page, setPage] = useState(props.startPage || 0); //Nuvarande sida
    const startPage = props.startPage || 0; //Startsida
    const { translate } = useLocale();

    useEffect(() => {
        setPage(startPage); //Återställer sidan till startsidan
    }, [props.showPreview]);


    const nextStep = (propLen) => {
        setPage(page  < propLen ? page + 1 : propLen);
      }
    
      const previousStep = () => {
        setPage(page > startPage ? page - 1 : startPage);
      }

      const renderChildren = () => { //https://sentry.io/answers/react-passing-props-to-children/
        return cloneElement(props.children, { display: page, values: props.values });
      }

    return (
        <Modal modalTitle={translate("Preview template")} isOpen={props.showPreview} onClose={() => props.setShowPreview(false) } maxWidth={"800px"}>

            {renderChildren()}

            <div className="flex spaceBetween">
            {page == startPage ? <p></p> : <button onClick={() => previousStep()} className='previewButton'>{translate("Back")}</button>}
            {props.continueButton ? <button onClick={() => nextStep(props.values.properties.length)} className='previewButton'>{page == startPage ? translate("Continue") : page == props?.values?.properties?.length ? translate("Submit response") : translate("Next")}</button>
                : <button onClick={() => nextStep(props.values.properties.length)} className='previewButton'>{translate("Next")}</button>
            }
            </div>
        </Modal >
    );
}

export default PreviewPaginator;